import React from 'react';
import { motion } from 'framer-motion';
import Topnav from '../../../components/topnav';
import styles from './landing.module.css';

const IframeScroll = () => {
  return (
    <section className={styles.Home}>
      <Topnav />
        {/* <div className={styles.Topnav}>
           <Topnav />
        </div> */}

        <div className={styles.main}>
          <motion.div
          className={styles.container}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
        >
          <iframe
            src="./frames/landing/index.html" /* https://alibhtty.github.io/mixtape-install/  https://alibhtty.github.io/frames/   http://192.168.1.122:5176/ */
            className={styles.iframe}
            title="Mixtape Start"
          />
        </motion.div>
        </div>
    </section>
  );
};

export default IframeScroll;